export const ROUTES = {
  LOGIN: "/fleet/analytics_login/v2/",
  VERIFY_OTP: "/fleet/analytics_login/v2/verify/",
  SESSION_CHECK: "/fleet/analytics_auth_verify/",
  LOGOUT: "/fleet/analytics_logout/",
};
